import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DottedDropdownAction } from '../dotted-dropdown/dotted-dropdown.component';
import { TranslateService } from '@ngx-translate/core';
declare let $: any;

@Component({
  selector: 'app-modal-dialog',
  templateUrl: './modal-dialog.component.html',
  styleUrls: ['./modal-dialog.component.scss']
})
export class ModalDialogComponent implements OnInit {

  constructor(private translate: TranslateService) { }

  @Input() modalId: string = "";
  @Input() title: string = "";
  @Input() isValid: boolean = true;
  @Input() errorMessage: string = "";
  @Input() okText: string = "";
  @Input() cancelText: string = this.translate.instant('common.buttons.cancel');
  @Input() titleClass: string = '';
  @Input() footerClass: string = '';
  @Input() static: boolean = false;
  @Input() hasCancel: boolean = true;
  @Input() hasClose: boolean = true;
  @Input() hasOk: boolean = true;
  @Input() customClose: boolean = false;
  @Input() extraButtons: DottedDropdownAction[] = [];

  // NEW: control dialog width/size from parent (e.g. "modal-xl", "modal-lg", etc)
  @Input() dialogClass: string = ""; // e.g. "modal-xl"

  @Output() onClose: EventEmitter<boolean> = new EventEmitter();
  @Output() onShow: EventEmitter<boolean> = new EventEmitter();

  submited: boolean = false;

  show() {
    this.submited = false;

    if (this.static === true) {
      $('#' + this.modalId).modal({ backdrop: 'static', keyboard: false }).modal("show");
    }
    else {
      $('#' + this.modalId).modal("show");
    }

    this.onShow.emit();
  }

  hide() {
    $('#' + this.modalId).modal("hide");
  }

  closeModal(success: boolean) {
    if (this.customClose != true) {
      if (success) {
        this.submited = true;
      }

      if (success && !this.isValid) {
        return;
      }

      $('#' + this.modalId).modal("hide");
    }

    this.onClose.emit(success);
  }

  ngOnInit(): void { 
  }

}
